import Component from '@glimmer/component';
import { assert } from '@ember/debug';
import { on } from '@ember/modifier';
import { t } from 'ember-intl';
import {
  HdsModal,
  HdsTextBody,
  HdsButtonSet,
  HdsButton,
} from '@hashicorp/design-system-components/components';

export default class IamInvitationsModalsResend extends Component {
  /**
   * Passed in callback function to cancel / close modal
   * @argument onClose
   * @type {Function}
   * @required
   */

  /**
   * Passed in callback function that cancels and then creates an invitation
   * @argument onSubmit
   * @type {Function}
   * @required
   */

  /**
   * Required argument whose value determines whether or not the modal is active
   * @argument isActive
   * @type {Boolean}
   * @required
   */

  /**
   * Required argument that is used to display the invitee's email address
   * @argument invite
   * @type {Object}
   * @required
   */

  constructor() {
    super(...arguments);

    assert(
      '<Iam::Invitations::Modals::Resend> required argument @onCancel is a defined function',
      typeof this.args.onClose === 'function'
    );

    assert(
      '<Iam::Invitations::Modals::Resend> required argument @onSubmit is a defined function',
      typeof this.args.onSubmit === 'function'
    );

    assert(
      '<Iam::Invitations::Modals::Resend> required argument @isActive is a defined boolean',
      typeof this.args.isActive === 'boolean'
    );

    assert(
      '<Iam::Invitations::Modals::Resend> required argument @invite is a defined object',
      typeof this.args.invite === 'object'
    );
  }
  <template>
    {{#if @isActive}}
      <HdsModal @onClose={{@onClose}} as |M|>
        <M.Header @icon="send">
          {{t "iam.invitations.modals.resend.title"}}
        </M.Header>
        <M.Body>
          <HdsTextBody
            @color="primary"
            @tag="p"
            data-test-iam-invitations-modals-resend-body
          >
            {{t
              "iam.invitations.modals.resend.body"
              inviteeEmail=@invite.inviteeEmail
              htmlSafe=true
            }}
          </HdsTextBody>
        </M.Body>
        <M.Footer>
          <HdsButtonSet>
            <HdsButton
              @color="primary"
              @text={{t "iam.invitations.modals.resend.confirm"}}
              disabled={{@onSubmit.isRunning}}
              data-test-iam-invitations-modals-resend-submit
              {{on "click" @onSubmit}}
            />
            <HdsButton
              @color="secondary"
              @text={{t "components.form.cancel"}}
              {{on "click" @onClose}}
            />
          </HdsButtonSet>
        </M.Footer>
      </HdsModal>
    {{/if}}
  </template>
}
